import { MedicalServiceWithPractitionersSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { EditIcon, Link, RemoveIcon, StyledFlex } from '@dreryk/react-components';

import { MedicalServiceName } from '../../shared/serviceName/name.types';

import { PractitionerMedicalServiceRemoveAction } from './PractitionerMedicalServiceOptionsCell.actions';
import { PractitionerMedicalServiceRemoveConfirmationEventInterceptor } from './remove/PractitionerMedicalServiceRemoveConfirmationEventInterceptor';
import { PractitionerMedicalServiceUpdateModalOpener } from './update/PractitionerMedicalServiceUpdateModalOpener';

type PractitionerMedicalServiceUpdateLinkProps = {
   readonly practitionerId: number;
   readonly medicalServiceId: number;
};

export const PractitionerMedicalServiceUpdateLink = (props: PractitionerMedicalServiceUpdateLinkProps): JSX.Element => {
   return (
      <PractitionerMedicalServiceUpdateModalOpener
         medicalServiceId={props.medicalServiceId}
         practitionerId={props.practitionerId}
      >
         {({ openModal }) => <Link testId={'practitionerMedicalServiceEdit'} icon={<EditIcon />} onClick={openModal} />}
      </PractitionerMedicalServiceUpdateModalOpener>
   );
};

type PractitionerMedicalServiceRemoveLinkProps = {
   readonly practitionerName: string;
   readonly hasMorePractitioners: boolean;
   readonly practitionerMedicalServiceId: number;
   readonly medicalServiceName: MedicalServiceName;
};

export const PractitionerMedicalServiceRemoveLink = (props: PractitionerMedicalServiceRemoveLinkProps): JSX.Element => {
   return (
      <PractitionerMedicalServiceRemoveConfirmationEventInterceptor
         medicalServiceName={props.medicalServiceName}
         practitionerName={props.practitionerName}
         hasMorePractitioners={props.hasMorePractitioners}
      >
         <PractitionerMedicalServiceRemoveAction practitionerMedicalServiceId={props.practitionerMedicalServiceId}>
            {({ removePractitionerMedicalService }) => (
               <Link
                  testId={'practitionerMedicalServiceRemove'}
                  onClick={removePractitionerMedicalService}
                  icon={<RemoveIcon />}
               />
            )}
         </PractitionerMedicalServiceRemoveAction>
      </PractitionerMedicalServiceRemoveConfirmationEventInterceptor>
   );
};

type PractitionerMedicalServiceOptionsCellProps = {
   readonly medicalService: MedicalServiceWithPractitionersSimple;
   readonly practitionerMedicalServiceId: number;
   readonly practitionerId: number;
   readonly practitionerName: string;
   readonly hasMorePractitioners: boolean;
};

export const PractitionerMedicalServiceOptionsCell = (
   props: PractitionerMedicalServiceOptionsCellProps
): JSX.Element => {
   return (
      <StyledFlex>
         <PractitionerMedicalServiceUpdateLink
            medicalServiceId={props.medicalService.id}
            practitionerId={props.practitionerId}
         />
         <PractitionerMedicalServiceRemoveLink
            medicalServiceName={props.medicalService.name}
            practitionerName={props.practitionerName}
            practitionerMedicalServiceId={props.practitionerMedicalServiceId}
            hasMorePractitioners={props.hasMorePractitioners}
         />
      </StyledFlex>
   );
};
